import React, { useEffect, useRef } from "react";
import { Col, Row } from "reactstrap";
import medal from "../assets/medal.png";
// import { AnimationOnScroll } from "react-animation-on-scroll";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { getWindowDimensions } from "../helper";
import { useSelector } from "react-redux";
gsap.registerPlugin(ScrollTrigger);

const Slide3 = () => {
  const { yearEndData } = useSelector((state) => state.commonSetting);
  const rayRef = useRef(null);
  const medalRef = useRef(null);

  useEffect(() => {
    const ray = rayRef.current;
    const medal = medalRef.current;
    const scroll = {
      scroller: ".st-year-end-slides-scroll",
      trigger: ".year-wrap-slide-3",
      // markers: true,
      start: "top center",
      toggleActions: "restart none none reverse",
    };
    gsap.fromTo(
      ".d-desc",
      { y: 200, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        scrollTrigger: scroll,
      }
    );
    gsap.to(ray, {
      rotate: 360,
      opacity: 1,
      duration: 1,
      delay: 2,
      scrollTrigger: scroll,
    });
    gsap.fromTo(
      medal,
      { opacity: 0 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: 1,
        scrollTrigger: scroll,
      }
    );
  }, []);

  return (
    <div className="year-wrap-slide-3" id="year-wrap-slide-3">
      <div className="w-80 m-auto">
        <Row>
          <Col lg={6} className="d-flex align-items-center">
            <div>
              <div
                className="rounded-circle bg-blue p-5 w-70 position-relative z-index-0 transition"
                style={{ background: "#067AC1" }}
              >
                <div className="ray_box z-index-1" ref={rayRef}>
                  <div className="ray ray1"></div>
                  <div className="ray ray2"></div>
                  <div className="ray ray3"></div>
                  <div className="ray ray4"></div>
                  <div className="ray ray5"></div>
                  <div className="ray ray6"></div>
                  <div className="ray ray7"></div>
                  <div className="ray ray8"></div>
                  <div className="ray ray9"></div>
                  <div className="ray ray10"></div>
                  <div className="ray ray11"></div>
                  <div className="ray ray12"></div>
                  <div className="ray ray13"></div>
                  <div className="ray ray14"></div>
                  <div className="ray ray15"></div>
                </div>
                <img
                  src={medal}
                  className="position-relative z-index-0 img-medal"
                  style={{ zIndex: 1 }}
                  ref={medalRef}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="text-center">
            <div className="d-flex flex-column gap-4">
              <b className="d-text-primary d-text-65">
                You had {yearEndData?.dispute_resolved == 0 ? null : "won"}
              </b>
              <b className="d-text-yellow d-text-180 dispute-resolved">
                {yearEndData?.dispute_resolved}
              </b>
              <b className="d-text-primary d-text-65">dispute case in 2022</b>
              <span className="d-text-40 d-desc">
                Incredible. Here our badge for the champion, you deserve it 🤩
              </span>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Slide3;
